import React, { useState, useEffect } from 'react';
import { Chart } from 'react-google-charts';
import axios from 'axios';

import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const jpurl = 'https://covid19-japan-web-api.now.sh/api/v1/prefectures';

var options = {
	region: 'JP',
	displayMode: 'regions',
	resolution: 'provinces'
};

const Geo = () => {

	const [ citys, setCitys ] = useState([]);
	const selection = {
		感染者: 'cases',
		死亡: 'deaths',
		回復: 'discharge',
		入院: 'hospitalize',
		PCR検査: 'pcr',
		感染者割合: 'cases_percent',
		死亡割合: 'deaths_percent',
		回復割合: 'discharge_percent',
		入院割合: 'hospitalize_percent',
		PCR検査割合: 'pcr_percent',
		人口: 'population'
	};

	const [ select, setSelect ] = useState('');
	const [dataCases, setDataCases] = useState([]);
	useEffect(() => {
		const fetchCitys = async () => {
			const result = await axios(jpurl);
			setCitys(result.data);
			setSelect('population')
		};
		fetchCitys();
	}, [])

	useEffect(() => {
		citys.map(city=>{
			city['cases_percent'] = city['cases'] / city['population'] * 100
			city['deaths_percent'] = city['deaths'] / city['population'] * 100
			city['discharge_percent'] = city['discharge'] / city['population'] * 100
			city['hospitalize_percent'] = city['hospitalize'] / city['population'] * 100
			city['pcr_percent'] = city['pcr'] / city['population'] * 100
		})
	}, [citys])
	useEffect(
		() => {
			select.split('_').length > 1 ? setDataCases([ [ 'City', '%' ] ]) : setDataCases([ [ 'City', '人数' ] ])
			citys.map((city) => {
				let listC = [];
				listC.push(city['name_ja']);
				listC.push(city[select]);
				setDataCases(dataCases => [...dataCases, listC]);
			});
		},
		[ select ]
	);




	const handleSelectChange = (e) => {
		setSelect(e.target.value);
	};
	return (
		<div>
			<h1 className="mt-5">新型コロナウイルスの地図データ</h1>
			<p>割合の例:『感染者割合』= その都道府県の感染者数 ÷ その都道府県の人口 × 100</p>
			<div style={{ textAlign:'center' }}>
				<FormControl className="w-50">
					<Select
						labelId="demo-simple-select-label"
						id="demo-simple-select"
						value={select}
						onChange={handleSelectChange}
					>
						{Object.keys(selection).map((s) => <MenuItem value={selection[s]}>{s}</MenuItem>)}
					</Select>
				</FormControl>
			</div>
			<Chart
				chartEvents={[
					{
						eventName: 'select',
						callback: ({ chartWrapper }) => {
							const chart = chartWrapper.getChart();
							const selection = chart.getSelection();
							if (selection.length === 0) return;
							const region = dataCases[selection[0].row + 1];
						}
					}
				]}
				chartType="GeoChart"
				width="1200px"
				height="800px"
				data={dataCases}
				options={options}
			/>
		</div>
	);
};

export default Geo;
